import api from '@/store/api/customer/user-log'
import * as mutationTypes from './mutation-types'

const initialState = () => ({
    userLog: {}
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        userLog: state => state.userLog
    },
    actions: {
        /**
         * @param {{customerId: number, logId: number}} data
         * @returns {Promise<*>}
         */
        showUserLog: async ({commit, dispatch}, data) => {
            try {
                const response = await api.showUserLog(data)
                commit(mutationTypes.SET_USER_LOG, response)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetUserLog: async ({commit}) => commit(mutationTypes.RESET_USER_LOG)
    },
    mutations: {
        [mutationTypes.SET_USER_LOG]: (state, data) => state.userLog = data,
        [mutationTypes.RESET_USER_LOG]: (state) => Object.assign(state, initialState())
    }
}
